import React from 'react'
import styles from './scrollToTop.module.sass'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/rootReducer'
import { scrollToTopSmooth } from '../../../../store/common/commonSlice'

const ScrollToTop = () => {
    const isPageScrolled = useSelector<RootState, boolean>((state) => state.common.isPageScrolled)
    const dispatch = useDispatch()

    const scrollTop = () => {
        dispatch(scrollToTopSmooth())
    }
    if (isPageScrolled)
        return (
            <div className={styles['scrollToTop']} onClick={scrollTop}>
                <div className={styles['button']}>
                    <img src={require('../../../../assets/ic-back.svg')} />
                </div>
            </div>
        )
    return null
}

export default ScrollToTop
